// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"3804acd8","80":"318181cb","358":"ad127ec3","496":"bdcf9af2","748":"dbb604d8","763":"345918dc","835":"fa0971bd","926":"a13df1fa"}[chunkId] + ".chunk.css";
};